import { render, staticRenderFns } from "./BsCard.vue?vue&type=template&id=1cb33292&"
import script from "./BsCard.vue?vue&type=script&lang=js&"
export * from "./BsCard.vue?vue&type=script&lang=js&"
import style0 from "./BsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports